:host {
  --z-notification--top-offset: 0;

  display: flex;
  width: 100%;
  box-sizing: border-box;
  align-items: flex-start;
  padding: calc(var(--space-unit) * 2);
  border-bottom: var(--border-size-medium) solid var(--color-surface03);
  font-family: var(--font-family-sans);
  outline: none;
}

:host[sticky] {
  position: sticky;
  top: var(--z-notification--top-offset);
}

:host[sticky],
:host([showshadow]) {
  box-shadow: var(--shadow-3);
}

:host([type="success"]) {
  background: var(--color-success-inverse);
}

:host([type="warning"]) {
  background: var(--color-warning-inverse);
}

:host([type="error"]) {
  background: var(--color-error-inverse);
}

.status-icon,
.close-button {
  /* simulate the line-height of the text
  to make the icon look correctly aligned with it. */
  display: flex;
  height: 20px;
  align-items: center;
}

:host([type="success"]) .status-icon {
  fill: var(--color-success01);
}

:host([type="warning"]) .status-icon {
  fill: var(--color-warning02);
}

:host([type="error"]) .status-icon {
  fill: var(--color-error01);
}

:host > button,
.content-container > button {
  padding: 0;
  border: none;
  margin: 0;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
}

.status-icon + .content-container {
  margin-left: var(--space-unit);
}

.content-container {
  display: flex;
  flex: 1 auto;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  row-gap: calc(var(--space-unit) * 2);
}

.content-text {
  max-width: 800px;
  color: var(--color-default-text);
  font-size: var(--font-size-2);
  font-weight: var(--font-rg);
  letter-spacing: 0.16px;
  line-height: 20px;
}

.action-button {
  color: var(--color-primary01);
  font-size: var(--font-size-1);
  font-weight: var(--font-sb);
  letter-spacing: 0.32px;
  line-height: 16px;
}

.action-button:focus {
  box-shadow: var(--shadow-focus-primary);
  outline: none !important;
}

.content-container + .close-button {
  margin-left: calc(var(--space-unit) * 2);
}

.close-button z-icon {
  fill: var(--color-primary01);
}

/* Tablet breakpoint */
@media only screen and (min-width: 768px) {
  .content-container {
    flex-wrap: nowrap;
  }

  .content-text + .action-button {
    margin-left: calc(var(--space-unit) * 5);
  }
}
